import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/svg/stamp-icons/ic-stamp-success.svg';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { useStore } from '../../../store';
import { VIEWS_MAP } from '../../../router/constants';
import { trackMixPanel } from '../../../services/mixpanel.service';

export const CompleteOnboarding = () => {
  const resetOnboardingData = useStore((state) => state.resetOnboardingData);
  const mfaData = useStore((state) => state.mfaData);
  const navigate = useNavigate();
  const handleSubmit = () => {
    resetOnboardingData();
    navigate(`/${VIEWS_MAP.LOGIN}`);
  };

  useEffect(() => {
    trackMixPanel('Page view', { pageName: 'Accountant setup complete' });
  }, []);

  return (
    <div className='flex flex-col items-center justify-center grow h-full bg-bw01'>
      <div className='py-[40px] px-[32px] bg-bw00 rounded-[12px] shadow-light flex flex-col items-center text-center'>
        <SuccessIcon className='w-[108px] mb-[24px]' />
        <Heading
          title={`Welcome to Lili, ${mfaData?.authorizedUserFullName}`}
          className='font-metricRSemibold text-[24px] text-bw08 mb-[8px]'
        />
        <Heading
          title={`Your accountant access to ${mfaData?.customerFirstName} ${mfaData?.customerLastName} Business account is ready`}
          className='font-metricR text-[16px] text-bw08 mb-[76px] max-w-[366px] break-words'
        />
        <Button
          onClick={handleSubmit}
          className='w-full bg-action03 hover:bg-action04 font-metricRMedium text-bw00 py-[17px] px-[60px] rounded-[4px]'
          title='Go to Account'
          id='completeOnboarding'
        />
      </div>
    </div>
  );
};
